import React from "react";
import { useTranslation } from "react-i18next";

const EFTDialog = (props: any) => {
    const { t: tLang } = useTranslation();
    return (
        <React.Fragment>
            <div className="dialog-header">
                <h1>{props.data.eftContent[0].type}</h1>
            </div>
            <div className="dialog-body">
                <p>{props.data.eftContent[0].value}</p>
            </div>

            {props.closeDialog && (
                <div className="dialog-footer">
                    <div className="row between-xs">
                        <div className="col-xs col-no-gutter flex-grow-null"></div>
                        <div className="col-xs col-no-gutter flex-grow-null">
                            <button
                                type="button"
                                className="btn-default btn-primary"
                                id="btn-ok-eft-text"
                                onClick={() => {
                                    window.addToDataLayer({ event: "Protection Plan - Close EFT Acknowledgement" });
                                    props.closeDialog();
                                }}
                            >
                                <span className="btn-text">{tLang("manageAccount.protectionPlan.billPaymentPopUp.btn.ok")}</span>
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </React.Fragment>
    );
};

export default EFTDialog;
